import Icon from "./icon.vue";
export default {
  name: "ValueViewer",
  components: {
    Icon
  },

  data() {
    return {
      copied: false
    };
  },

  props: {
    value: !String,
    canCopy: Boolean
  },
  methods: {
    copy() {
      const el = document.createElement('textarea');
      el.value = this.$props.value;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 5000);
    }

  }
};